// So this right here, is what I think should really be in formality.
// I want a form that I can add, give some children, set some initial values and just get an action dispatched when the form is valid
// I don't want to know about creating the store, marshalling changes into the form elements, checking that it's mounted before setting state
import React from 'react'
import PropTypes from 'prop-types'
import { Store, Form as FormalityForm } from 'react-formality'

class Form extends React.Component {
	constructor(props) {
		super(props)

		this.state = { values: props.initialValues || {} }

		this.store = new Store(
			{ ...this.state.values },
			(values) => {
				const prevValues = { ...this.state.values }
				if (this.mounted) {
					this.setState({ values })
				}
				props.onChange({ prevValues, values, store: this.store })
			},
			(validationResults, isValid) => {
				if (this.mounted) {
					this.setState({ validationResults, isValid })
				}
			}
		)

		this.form = React.createRef()
		this.submit = this.submit.bind(this)
		this.onSubmit = this.onSubmit.bind(this)
	}

	componentDidMount() {
		this.mounted = true
	}

	componentWillUnmount() {
		this.mounted = false
	}

	onSubmit(e, values, isValid, validationResults) {
		this.setState({ values, isValid, validationResults })
		this.props.onSubmit({ values, isValid, validationResults, store: this.store })
	}

	submit() {
		this.form.current.submit()
	}

	render() {
		const { children, className, initialValues, onSubmit, onChange, ...rest } = this.props
		return (
			<FormalityForm {...rest} className={className} onSubmit={this.onSubmit} store={this.store} ref={this.form}>
				{children({
					store: this.store,
					values: this.state.values,
					isValid: this.state.isValid,
					validationResults: this.state.validationResults
				})}
			</FormalityForm>
		)
	}
}

Form.propTypes = {
	children: PropTypes.func.isRequired,
	className: PropTypes.string,
	initialValues: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	onSubmit: PropTypes.func,
	onChange: PropTypes.func
}

Form.defaultProps = {
	className: undefined,
	initialValues: {},
	onSubmit: () => null,
	onChange: () => null
}

export default Form



// WEBPACK FOOTER //
// ./src/components/Form/index.jsx